<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Dettaglio progetto">
                <div ngbDropdown class="d-inline-block">
                    <button type="button" class="btn btn-outline-primary mt-3 mr-2" ngbDropdownToggle id="progettoDettaglioAzioni">
                        Azioni
                        <app-toolkit-bl-icon icon="arrow-down-triangle" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="progettoDettaglioAzioni">
                        <button ngbDropdownItem [routerLink]="['..']">
                            <app-toolkit-bl-icon icon="arrow-left" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                            Torna indietro
                        </button>
                        <button ngbDropdownItem (click)="goToModifica()">
                            <app-toolkit-bl-icon icon="pencil" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                            Modifica
                        </button>
                        <button ngbDropdownItem (click)="deleteProgetto()">
                            <app-toolkit-bl-icon icon="close" cssClass="icon icon-sm icon-danger"></app-toolkit-bl-icon>
                            Elimina
                        </button>
                    </div>
                </div>
            </app-toolkit-page-title>
            <ngb-accordion aria-busy="true" #acc="ngbAccordion" activeIds="tab-1">
                <ngb-panel id="tab-1" title="Opere associate">
                    <ng-template ngbPanelContent>
                        <app-toolkit-progetto-tab-opere-associate [canEdit]="false" [items]="opereAssociateList" [formGroup]="criteriaForm" [datalist]="datalist"></app-toolkit-progetto-tab-opere-associate>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-2" title="Anagrafica del progetto">
                    <ng-template ngbPanelContent>
                        <app-toolkit-progetto-tab-anagrafica-progetto [canEdit]="false" [formGroup]="criteriaForm"></app-toolkit-progetto-tab-anagrafica-progetto>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-3" title="Atti di finanziamento">
                    <ng-template ngbPanelContent>
                        <app-toolkit-progetto-tab-leggi-progetto [canEdit]="false" [items]="leggiProgettoList" [datalist]="datalist"></app-toolkit-progetto-tab-leggi-progetto>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-4" title="Documenti a corredo">
                    <ng-template ngbPanelContent>
                        <app-toolkit-progetto-tab-documenti [canEdit]="false" [items]="documentoProgettoList" [datalist]="datalist"></app-toolkit-progetto-tab-documenti>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
    </div>
</div>